import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { isEmpty, map } from 'lodash'

import TabOrdersList from '../../containers/tabs/TabOrdersList'
import Button from '../../components/Button'

import styles from './CustomerTabOrders.module.scss'


// TODO - display suites currently based on pre-orders. Need to re-do that for suite/customer assignments per user login
const CustomerTabOrders = ({ displaySuites, focusedItemId, highlightedIds, searchQuery, onNewOrderTapped, onSettingsTapped, className }) => {
  const classNames = cn(styles.customerTabOrders, className)
  let content = null

  if (!isEmpty(displaySuites)) {
    content = map(displaySuites, (displaySuite) => {
      const { customerId, revenueCenterId } = displaySuite
      const style = {}
      let isFocused = false

      if (searchQuery) {
        if (focusedItemId === `${revenueCenterId}${customerId}`) {
          isFocused = true
        } else if (!highlightedIds.includes(`${revenueCenterId}${customerId}`)) {
          style.opacity = '.1'
        }
      }
    
      return (
        <div className={styles.customerContainer} key={displaySuite.displayName} style={style}>
          <div className={styles.customerHeader}>
            <h2 className={styles.customerTitle}>{displaySuite.displayName}</h2>
            <Button
              className={styles.newOrderButton}
              onClick={() => onNewOrderTapped(customerId, revenueCenterId)}
            >new order</Button>
            <Button
              className={styles.settingsButton}
              onClick={() => onSettingsTapped(customerId, revenueCenterId)}
              disabled={displaySuite.settingsDisabled}
            >settings</Button>
          </div>
          <TabOrdersList className={styles.ordersContainer} customerId={customerId} revenueCenterId={revenueCenterId} showHeader={false} isFocused={isFocused} showClosedTabs/>
        </div>
      )
    })
  }

  return (
    <div className={classNames}>
      {content}
    </div>
  )
}

CustomerTabOrders.defaultProps = {
  displaySuites: [],
  onNewOrderTapped: () => {},
  onSettingsTapped: () => {},
}

CustomerTabOrders.propTypes = {
  displaySuites: PropTypes.array,
  onNewOrderTapped: PropTypes.func,
  onSettingsTapped: PropTypes.func,
}

export default CustomerTabOrders
